import AppButton from "@/components/AppButton.vue";
import HeaderRelease from "@/components/HeaderRelease.vue";
import ImageUploader from "@/components/ImageUploader.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import TextLink from "@/components/TextLink.vue";
import Request from "@/ts/Request";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    ImageUploader,
    HeaderRelease,
    AppButton,
    TextLink,
    ModalCodigo,
  },
})
export default class AddSupportRequest extends Vue {
  subjectMatters: any = [];
  stores: any = [];
  file: any = [];
  showDeleteAction = false;
  showModalImageUp = false;
  showModal = false;
  showModalSuccess = false;
  errorMessage =
    "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde.";
  mensagem = "";
  subjectMattersId: any = "";
  storeId: any = "";

  mounted() {
    this.getSubjectMatters();
    this.getStores();
  }

  getSubjectMatters() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "getSubjectMatters";
      req.callbackSuccess = function (response: any) {
        self.subjectMatters = response.response.subjectMatters;
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  goBack() {
    this.$router.go(-1);
  }

  newPreviewFiles(f: any) {
    this.file = f;
    this.ifHasFile("Arquivo anexado");
    this.showDeleteAction = true;
    this.closeModalImageUp();
  }

  deleteImage() {
    this.file = [];
    this.showDeleteAction = false;
  }

  openModalImageUp() {
    this.showModalImageUp = true;
  }

  closeModalImageUp() {
    this.showModalImageUp = false;
  }

  ifHasFile(NAME: any) {
    const inputs = document.querySelectorAll(".inputfile");
    const self = this;
    Array.prototype.forEach.call(inputs, function (input: any) {
      const label = input.nextElementSibling;
      label.innerHTML = NAME;
    });
  }

  addSupporRequest() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        SUBJECT_MATTER_ID: this.subjectMattersId,
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        NRORG: sessionStorage.getItem("NRORG"),
        STORE_ID: this.storeId,
        DESCRIPTION: self.mensagem,
        FILE: self.file,
      };
      req.route = "createSupportRequest";
      req.callbackSuccess = function (response: any) {
        self.showModalSuccess = true;
        self.deleteImage();
      };
      req.callbackError = function (error: any) {
        const errorCode =
          typeof error.response == "undefined"
            ? null
            : error.response.data.errorCode;
        if (errorCode == 234) {
          self.mostraModal("Favor anexar apenas imagens.");
        } else if (!errorCode) {
          self.showModalSuccess = true;
          self.deleteImage();
        } else
          self.mostraModal(
            "Ocorreu um erro inesperado ao enviar a solicitação."
          );
        req.unblockTouch();
      };
      req.blockTouchEvents = true;
      req.send();
    } catch (e) {
      const mensagem =
        "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde";
      this.mostraModal(mensagem);
    }
  }

  mostraModal(message: string) {
    this.errorMessage = message;
    this.showModal = true;
  }

  fechaModal() {
    this.showModal = false;
  }

  fechaModalSuccess() {
    this.showModal = false;
    this.$router.go(-1);
  }

  getStores() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "getStores";
      req.callbackSuccess = (response: any) => {
        self.stores = response.stores;
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }
}
